import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Artists from './pages/Artists';
import Songs from './pages/Songs';
import News from './pages/News';
import Events from './pages/Events';
import Products from './pages/Products';
import SiteContent from './pages/SiteContent';
import Partners from './pages/Partners';
import Videos from './pages/Videos';
import Broadcast from './pages/Broadcast';
import Promotions from './pages/Promotions';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="artists" element={<Artists />} />
          <Route path="songs" element={<Songs />} />
          <Route path="news" element={<News />} />
          <Route path="events" element={<Events />} />
          <Route path="products" element={<Products />} />
          <Route path="site-content" element={<SiteContent />} />
          <Route path="partners" element={<Partners />} />
          <Route path="videos" element={<Videos />} />
          <Route path="broadcast" element={<Broadcast />} />
          <Route path="promotions" element={<Promotions />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
